import * as MODULES from '../module-codes'
import axios from 'axios'

export const state = () => ({
    videoSubmissions: []
})

export const getters = {
}

export const actions = {
    submitRecording: ({ commit, dispatch }, payload) => {
        commit('ADD_NEW_VIDEO_RECORDING', payload)
        dispatch('updateModuleInDB')
    },
    uploadVideo: async ({commit, dispatch}, payload) => {
        let formData = new FormData()
        formData.append('video', payload)
        axios
          .post('/api/file/videoRecorder/upload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            commit('ADD_NEW_VIDEO_RECORDING', res.data)
            dispatch('updateModuleInDB')
          })
    },
    updateModuleInDB: async ({ state, rootState }) => {
        let content = {
            videoSubmissions: state.videoSubmissions
        }
        await axios.post('/api/updateModule', {
            params: {
                moduleState: content,
                moduleName: MODULES.VIDEO_RECORDER,
                pcs: localStorage.getItem('pcs'),
                classId: rootState.auth.classId,
            } 
        })
    },
    populateFromDB: async ({ commit }, payload) => {
        if (payload) {
            commit('SET_VIDEO_RECORDER_USER_CONTENT', payload)
        }
    },
}

export const mutations = {
    SET_VIDEO_RECORDER_USER_CONTENT(state, payload) {
        state.videoSubmissions = payload.videoSubmissions
    },
    ADD_NEW_VIDEO_RECORDING(state, payload) {
        state.videoSubmissions.push(payload)
    },
    CLEAR_STATE: state => {
        state.videoSubmissions = []
      },
}